import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';

import { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';
import { CancellationTokenManager } from 'shared/utils/cancellationTokenManager';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    cancellationTokenManager: new CancellationTokenManager(),
    microfrontendsRegistry: registry(),
  };
};
